import "../style/results.css"
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../context/AppContext";

export function Results() {
    const navigate = useNavigate();
    const appContext = useContext(AppContext);
    const [correctAnswers, setCorrectAnswers] = useState(0);
    const [displayCorrectAnswers, setDisplayCorrectAnswers] = useState(0);
    const [bestCategory, setBestCategory] = useState(null);
    const [worstCategory, setWorstCategory] = useState(null);
    const [bestTime, setBestTime] = useState(0);
    const [worstTime, setWorstTime] = useState(0);
    const [bestStreak, setBestStreak] = useState(null);

    const processCategories = (array, best) => {
        // best and worst category logic:
        // if there is most of single category entries in a pool, that category is selected as best/worst
        // if there is same amount of antries a category with best or worst time will be selected

        if (array.length > 0) {
            let frequency = {};
            for (let i = 0; i < array.length; i++) {
                const element = array[i].category;
                frequency[element] = (frequency[element] || 0) + 1;
            }

            let maxFrequency = 0;
            let mostFrequentElement = [];
            for (const element in frequency) {
                if (frequency[element] > maxFrequency) {
                maxFrequency = frequency[element];
                }
            }
            for (const element in frequency) {
                if (frequency[element] === maxFrequency) {
                    mostFrequentElement.push(element);
                }
            }
            
            if (mostFrequentElement.length === 1) {
                return mostFrequentElement[0];
            } else {
                let time = array[0].time;
                let result = array[0].category;
                for (let i = 0; i < array.length; i++) {
                    if (mostFrequentElement.includes(array[i].category)) {
                        if (best) {
                            if (array[i].time < time) {
                                result = array[i].category;
                            }
                        } else {
                            if (array[i].time > time) {
                                result = array[i].category;
                            }
                        }
                    }
                }
                return result;
            }
        } else {
            return "None";
        }
    };

    const calculateReport = () => {
        const report = appContext.questions ? appContext.quizStats : null;
        let correctAnswersDummy = 0;
        let bestCategoryPool = [];
        let worstCategoryPool = [];
        let bestTimeDummy = null;
        let worstTimeDummy = null;
        let streakTemp = 0;
        let streakPool = [];
        //let streak = 0;
        
        // sort report
        if (appContext.questions) {
            bestTimeDummy = report[0].time;
            worstTimeDummy = report[0].time;
            
            for (let i = 0; i < report.length; i++) {
                // get number of correct answers
                if (report[i].correct) {
                    correctAnswersDummy = correctAnswersDummy + 1;
                    streakTemp = streakTemp + 1;
                    if (i === report.length - 1) {
                        streakPool.push(streakTemp)
                    }
                    // get best category
                    bestCategoryPool.push(report[i]);
                } else {
                    // get worst category
                    worstCategoryPool.push(report[i]);
                    if (streakTemp !== 0) {
                        streakPool.push(streakTemp);
                        streakTemp = 0;
                    };
                }
                
                // get best and worst time
                if (report[i].time < bestTimeDummy) {
                    bestTimeDummy = report[i].time;
                };
                if (report[i].time > worstTimeDummy) {
                    worstTimeDummy = report[i].time;
                }
            }

            let streakResult = streakPool.length > 0 ? streakPool[0] : 0;
            if (streakPool.length > 0) {
                for (let i = 0; i < streakPool.length; i++) {
                    if (streakPool[i] > streakResult) {
                        streakResult = streakPool[i];
                    }
                }
            }
            setBestStreak(streakResult);

            setCorrectAnswers(correctAnswersDummy);
            setBestTime(bestTimeDummy);
            setWorstTime(worstTimeDummy);
            setBestCategory(processCategories(bestCategoryPool, true));
            setWorstCategory(processCategories(worstCategoryPool, false));
        }
        
    };

    const backToMenu = () => {
        appContext.clearQuestions();
        navigate("/")
    };

    useEffect(()=>{
        if (appContext.questions === null) {
            navigate("/");
        }
    },[navigate, appContext.questions]);

    useEffect(()=>{
        calculateReport();
    // eslint-disable-next-line
    },[]);

    useEffect(() => {
        if (correctAnswers !== 0) {
            const incrementer = setInterval(() => {
                setDisplayCorrectAnswers((c) => {
                  if(c < correctAnswers) return c+1;
                  clearInterval(incrementer);
                  return c;
                });
              }, 100);
        }
    },[correctAnswers]);

    return(
        <div className="results">
            <div className="upper">
                <div className="circle-container">
                    <div className="correct-numbers">
                        {appContext.questions ? displayCorrectAnswers : null}/{appContext.questions ? appContext.questions.results.length : null}
                    </div>
                    <div className="correct-numbers-label">
                        Questions correct
                    </div>
                </div>
            </div>
            <div className="lower">
                <div className="results-text">
                    {appContext.settings.category === "0" ? <span>Best category: {appContext.questions ? bestCategory : null} </span> : <span></span>}
                    {appContext.settings.category === "0" ? <span>Worst category: {appContext.questions ? worstCategory : null} </span> : <span></span>}
                    <span>Fastest answer: {appContext.questions ? bestTime.toFixed(2) : null} seconds</span>
                    <span>Slowest answer: {appContext.questions ? worstTime.toFixed(2) : null} seconds</span>
                    <span>Best streak: {appContext.questions ? bestStreak : null}</span>
                </div>
                <div className="button-container">
                    <button className="button button-finish" onClick={backToMenu}>
                        <span className="button-text">
                            FINISH
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
}